import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import AngledAxisTick from '../AngledAxisTick';
import spinner from '../../../images/spinner-ripple.svg'
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';

const MatrixDevelopmentCategoricalBarChart = ({ data, totalResponses }) => {
  const [hovered, setHovered] = useState(null);

  if (!data || data.length === 0) {
    return <img src={spinner} alt="Loading..." style={{ width: '50px', height: '50px' }} />;
  }

  // extract row titles (keys except 'name')
  const rowKeys = Object.keys(data[0]).filter((k) => k !== "name");

  // gather all category labels
  const categories = new Set();
  data.forEach((item) => {
    rowKeys.forEach((r) => {
      const counts = item[r]?.counts || {};
      Object.keys(counts).forEach((c) => categories.add(c));
    });
  });
  const categoryList = Array.from(categories);

  // transform data: each row–category becomes own key
  const chartData = data.map((item) => {
    const out = { name: item.name };
    rowKeys.forEach((r) => {
      const counts = item[r]?.counts || {};
      categoryList.forEach((c) => {
        out[`${r}-${c}`] = counts[c] || 0;
      });
    });
    return out;
  });

  // build series for Recharts
  const series = rowKeys.flatMap((r) => {
    const color = data[0][r]?.color || '#206c7f';
    return categoryList.map((c) => ({
      dataKey: `${r}-${c}`,
      name: `${r}: ${c}`,
      fill: color,
    }));
  });

  return (
    <>
     
      <ResponsiveContainer width="100%" height={500}>
        <BarChart
          data={chartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis
          dataKey="name"
          tick={<AngledAxisTick />}
          interval={0}
          height={70}
          axisLine={false}
          tickLine={false} />
          <YAxis
          axisLine={false}
          tickLine={false}
          allowDecimals={false} />
          <Legend verticalAlign="bottom" maxWidth={'300px'} />
          <Tooltip
            wrapperStyle={{ zIndex: 1000 }}
            contentStyle={{
              maxWidth: '450px', 
              whiteSpace: 'normal',
              overflowWrap: 'break-word',
            }}
          />
          
          {series.map((s, i) => (
            <Bar
              key={i}
              dataKey={s.dataKey}
              name={s.name}
              fill={s.fill}
              fillOpacity={hovered && hovered !== s.dataKey ? 0.3 : 1}
              onMouseEnter={() => setHovered(s.dataKey)}
              onMouseLeave={() => setHovered(null)}
           stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default MatrixDevelopmentCategoricalBarChart;